<template>
    <v-select
        v-model="selected"
        :options="options"
        :filterable="false"
        :loading="loading"
        label="StockName"
        :placeholder="placeholder"
        :clearable="true"
        @search="onSearch"
        @open="onOpen"
        @close="onClose"
        @input="onInput">

        <!-- Açılır listedeki her stok: stok adı tam (kısaltmasız), altında muted stok kodu -->
        <template #option="opt">
            <div class="scs-option">
                <div class="scs-name">{{ opt.StockName || '-' }}</div>
                <small class="text-muted scs-code">{{ opt.StockCode }}</small>
            </div>
        </template>

        <!-- Seçili gösterim -->
        <template #selected-option="opt">
            <div class="scs-selected">
                <span class="scs-selected-name">{{ opt.StockName || '-' }}</span>
                <small class="text-muted ml-50">{{ opt.StockCode }}</small>
            </div>
        </template>

        <template #spinner="{ loading }">
            <b-spinner small v-if="loading"></b-spinner>
        </template>

        <template #no-options>
            {{ loading ? 'Yükleniyor...' : 'Sonuç bulunamadı.' }}
        </template>

        <!-- Sonsuz kaydırma sentinel'i -->
        <template #list-footer>
            <li v-show="hasMore" ref="loadMore" class="scs-loader text-center text-muted">
                <b-spinner small></b-spinner>
                <span class="ml-50">Daha fazla yükleniyor...</span>
            </li>
        </template>
    </v-select>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { SpecialControlStockApi } from '@/api/special-control-stock'

const PAGE_SIZE = 10

export default {
    name: 'StockSearchSelect',
    components: { BSpinner },
    props: {
        value: {
            type: Object,
            default: null
        },
        placeholder: {
            type: String,
            default: 'Stok adı veya kodu ile arayın...'
        },
        searchDelay: {
            type: Number,
            default: 500
        }
    },
    data(){
        return {
            selected: this.value,
            options: [],
            query: '',
            offset: 0,
            hasMore: false,
            loading: false,
            searchTimer: null,
            observer: null
        }
    },
    watch: {
        value(val){
            this.selected = val
        }
    },
    beforeDestroy(){
        this.detachObserver()
    },
    methods: {
        onInput(val){
            this.$emit('input', val)
        },
        onOpen(){
            if(this.options.length === 0 && !this.loading){
                this.resetAndLoad('')
            }
            this.$nextTick(() => this.attachObserver())
        },
        onClose(){
            this.detachObserver()
        },
        onSearch(search){
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.resetAndLoad(search)
            }, this.searchDelay)
        },
        resetAndLoad(search){
            this.query = search
            this.offset = 0
            this.options = []
            this.hasMore = false
            this.load()
        },
        load(){
            this.loading = true
            SpecialControlStockApi.SearchNetsisStocks({
                Query: this.query,
                Limit: PAGE_SIZE,
                Offset: this.offset
            }).then(res => {
                const list = (res.data && res.data.Data) ? res.data.Data : []
                this.options = this.offset === 0 ? list : this.options.concat(list)
                this.hasMore = list.length === PAGE_SIZE
                this.offset += list.length
                this.loading = false
                this.$nextTick(() => this.attachObserver())
            }).catch(() => {
                this.loading = false
                this.hasMore = false
            })
        },
        loadMore(){
            if(this.hasMore && !this.loading){
                this.load()
            }
        },
        attachObserver(){
            this.detachObserver()
            const el = this.$refs.loadMore
            if(!el) return
            this.observer = new IntersectionObserver(entries => {
                if(entries[0].isIntersecting){
                    this.loadMore()
                }
            }, { threshold: 0.5 })
            this.observer.observe(el)
        },
        detachObserver(){
            if(this.observer){
                this.observer.disconnect()
                this.observer = null
            }
        },
        clear(){
            this.selected = null
            this.$emit('input', null)
        }
    }
}
</script>

<style scoped>
.scs-option{
    padding: 0.15rem 0;
    white-space: normal;      /* stok adını kısaltma - tam göster */
    word-break: break-word;
}
.scs-name{
    white-space: normal;
    line-height: 1.25;
}
.scs-code{
    font-size: 0.75rem;
}
.scs-selected{
    display: flex;
    align-items: center;
    white-space: normal;
}
.scs-loader{
    padding: 0.5rem;
    list-style: none;
}
</style>
